import React, { Component } from 'react';
import './IT.css';
import data from '../../data/IT.js';

import Layout from '../../components/Layout/Layout';
import Icon from '../../components/Icon/Icon';
import Intro from '../../components/Intro/Intro';

import QuickFacts from './QuickFacts/QuickFacts';
import Reference from './Reference/Reference';
import SoftwareList from './SoftwareList/SoftwareList';

class IT extends Component {
	render() {
		return (
			<Layout colors={ data.colors }>
				<div className="IT">
					<Intro>
						<Icon icon="it.intro" title="Super Tech Support" />
						<div className="intro-title">
							<h1>Super <span>Tech</span> Support</h1>
							<p>
								Questions about what programs we use or what you’re allowed to download?
								<br />
								You’ve come to the right place.
							</p>
						</div>
						
						<div className="contact">
							<div className='contact-spacer' />
							<Icon icon="it.itGuru" className="guru-icon" title="The IT Guru" />
							<div className="name-title">
								<p>The IT Guru</p>
								<p>Michael Magill</p>
							</div>
							<div className="message">
								<p className="message-mattermost">Michael Magill</p>
								<p className="message-email">support@idsi.com</p>
							</div>
							<div className="phone">
								<p className="phone-office">(703) 766-9631</p>
								<p className="phone-cell">(703) 655-5260</p>
							</div>
						</div>
					</Intro>
					
					<QuickFacts cards={ data.quickFacts } />
					<SoftwareList list={ data.software } docs={ data.docs } />
					<Reference videos={ data.referenceVideos } />
				</div>
			</Layout>
		);
	}
};

export default IT;



// WEBPACK FOOTER //
// ./src/pages/IT/IT.js